const namespaced = true

const defaultState = () => {
  return {
    loading: true,
    vehicles: [],
    companyFilter: '',
    grid: 'row',
    page: 1,
    lastPage: 100,
    confirm: false,
    excelModal: false,
    operation: false,
    detail: false,
    selectedVehicle: {},
    search: '',
    brands: [],
    models: [],
    modelDetails: [],
    edit: false,
    locationFilter: {},
    locations: [],
    multiFilter: [],
    selectedVehicles: [],
    groups: [],
    visibleColumns: [
      {
        name: 'SELECT',
        val: 'selection'
      },
      {
        name: 'UNIT',
        val: 'unit'
      },
      {
        name: 'VIN',
        val: 'vin'
      },
      {
        name: 'BRAND',
        val: 'brand'
      },
      {
        name: 'MODEL',
        val: 'model'
      },
      {
        name: 'MODEL YEAR',
        val: 'model_year'
      },
      {
        name: 'CLASS NAME',
        val: 'class_name'
      },
      {
        name: 'IN SERVICE DATE',
        val: 'in_service_date'
      },
      {
        name: 'LOCATION',
        val: 'location'
      },
      {
        name: 'CONDITION',
        val: 'condition'
      },
      {
        name: 'AUCTION VALUE',
        val: 'last_mileage_record'
      },
      {
        name: 'MANUAL SELECTION',
        val: 'tags'
      },
      {
        name: 'ACTIONS',
        val: 'actions'
      },
      {
        name: 'STATUS',
        val: 'status'
      }
    ],
    tagOperation: false,
    tagQ: [],
    statusQ: [],
    setDefaultMarketValueDialog: {
      show: false,
      id: null,
      vin: null,
      currentValue: null,
    },
    setMarketValueHistoryDialog: {
      show: false,
      id: null
    },
    setSellDialog: {
      show: false,
      items: [],
      nested: false,
      completed: false,
    },
    setSellHistoryDialog: {
      show: false,
    }
  }
}

const state = defaultState()
const actions = {
  SET_SELECTED_VEHICLE({ commit }, vehicle) {
    commit('SET_SELECTED_VEHICLE', vehicle)
  }
}
const mutations = {
  UPDATE_VEHICLE_CONDITION(state, { condition, vin, unit }) {
    const index = state.vehicles.findIndex(item => item.vin === vin)
    index !== -1
      ? state.vehicles.splice(index, 1, {
          ...state.vehicles[index],
          condition
        })
      : ''
  },
  SET_VEHICLES_TAGS_CHANGED(state, vehicles) {
    for (let i = 0; i < state.vehicles.length; i++) {
      for (let j = 0; j < vehicles.length; j++) {
        state.vehicles[i].id === vehicles[j].vehicle ? (state.vehicles[i].tags = vehicles[j].tags) : ''
      }
    }
    state.selectedVehicles = []
  },
  REMOVE_TAG_EXISTING_VEHICLE(state, tag_id) {
    for (let i = 0; i < state.vehicles.length; i++) {
      const tags = [...state.vehicles[i].tags]
      for (let j = 0; j < tags.length; j++) {
        if (tags[j].id === tag_id) tags.splice(j, 1)
      }
      state.vehicles[i].tags = tags
    }
  },
  SET_TAG_Q(state, tagQ) {
    state.tagQ = tagQ
  },
  SET_STATUS_Q(state, statusQ) {
    state.statusQ = statusQ
  },
  SET_SELECTED_VEHICLES(state, selectedVehicles) {
    state.selectedVehicles = [...selectedVehicles]
  },
  UPDATE_VEHICLE_EXISTS_TAG(state, { name, color, vehicle_id, tag_id }) {
    const index = state.vehicles.findIndex(vehicle => vehicle.id === vehicle_id)
    if (index !== -1) {
      const tags = [...state.vehicles[index].tags]
      for (let i = 0; i < tags.length; i++) {
        if (tags[i].id === tag_id) tags.splice(i, 1, { ...tags[i], name, color })
      }
      state.vehicles[index].tags = tags
    }
  },
  SET_VEHICLE_TAG(state, localVehicle) {
    const index = state.vehicles.findIndex(vehicle => vehicle.id === localVehicle.id)
    const copy = { ...state.vehicles[index], tags: localVehicle }
    index !== -1 ? state.vehicles.splice(index, 1, copy) : ''
  },
  SET_TAG_OPERATION(state, tagOperation) {
    state.tagOperation = tagOperation
  },
  SET_VISIBLE_COLUMNS(state, visibleColumns) {
    state.visibleColumns = visibleColumns
  },
  resetState(state) {
    Object.assign(state, defaultState())
  },
  CHECK_EDIT_LOCATION(state, location) {
    const index = state.locations.map(item => item.id).indexOf(location.id)
    index !== -1 ? state.locations.splice(index, 1, location) : ''

    const multiIndex = state.multiFilter.map(item => item.id).indexOf(location.id)
    multiIndex !== -1 ? state.multiFilter.splice(multiIndex, 1, location) : ''
  },
  REM_LOCATION_TO_SELECTED_LOCATION(state, id) {
    const index = state.locations.map(item => item.id).indexOf(id)
    index !== -1 ? state.locations.splice(index, 1) : ''

    const multiIndex = state.multiFilter.map(item => item.id).indexOf(id)
    multiIndex !== -1 ? state.multiFilter.splice(multiIndex, 1) : ''
  },
  ADD_LOCATION_TO_SELECTED_LOCATION(state, newVal) {
    const index = state.locations.map(item => item.id).indexOf(newVal.id)
    index === -1 ? (state.locations = [...state.locations, newVal]) : ''
  },
  DELETE_SELECTED_VEHICLE(state, id) {
    state.companyFilter.id === id ? (state.companyFilter = {}) : ''
    state.multiFilter = []
  },
  SET_CHECK_EDIT_COMPANY(state, companyFilter) {
    state.companyFilter.id === companyFilter.id ? (state.companyFilter = companyFilter) : ''
  },
  RESET_FILTER(state, reset) {
    state.multiFilter = []
    state.search = ''
    state.companyFilter = {}
    state.visibleColumns = [
      {
        name: 'SELECT',
        val: 'selection'
      },
      {
        name: 'UNIT',
        val: 'unit'
      },
      {
        name: 'VIN',
        val: 'vin'
      },
      {
        name: 'BRAND',
        val: 'brand'
      },
      {
        name: 'MODEL',
        val: 'model'
      },
      {
        name: 'MODEL YEAR',
        val: 'model_year'
      },
      {
        name: 'CLASS NAME',
        val: 'class_name'
      },
      {
        name: 'LOCATION',
        val: 'location'
      },
      {
        name: 'TAGS',
        val: 'tags'
      },
      {
        name: 'ACTIONS',
        val: 'actions'
      },
      {
        name: 'STATUS',
        val: 'status'
      }
    ]
  },
  SET_GROUPS(state, groups) {
    state.groups = groups
  },
  SET_MULTI_FILTER(state, multiFilter) {
    state.multiFilter = multiFilter
  },
  SET_LOCATION_FILTER(state, locationFilter) {
    state.locationFilter = locationFilter
  },
  REMOVE_MULTI_FILTER(state, index) {
    state.multiFilter.splice(index, 1)
  },
  SET_LOCATIONS(state, locations) {
    state.locations = locations
  },
  EDIT_VEHICLE(state, vehicle) {
    const index = state.vehicles.map(vehicle => vehicle.id).indexOf(vehicle.id)
    state.vehicles.splice(index, 1, vehicle)
  },
  ADD_VEHICLE(state, vehicle) {
    state.vehicles.unshift(vehicle)
  },
  SET_VEHICLE_DETAILS(state, details) {
    state.modelDetails = details
  },
  SET_VEHICLE_MODELS(state, models) {
    state.models = models
  },
  SET_VEHICLE_BRANDS(state, brands) {
    state.brands = brands
  },
  SET_EDIT(state, edit) {
    state.edit = edit
  },
  SET_SELECTED_VEHICLE(state, selectedVehicle) {
    state.selectedVehicle = selectedVehicle
  },
  SET_SEARCH(state, search) {
    state.search = search
  },
  SET_VEHICLE_OPERATION(state, operation) {
    state.operation = operation
  },
  SET_CONFIRM(state, confirm) {
    state.confirm = confirm
  },
  SET_DETAIL(state, detail) {
    state.detail = detail
  },
  SET_COMPANY_FILTER(state, companyFilter) {
    state.companyFilter = companyFilter
  },
  SET_GRID_TYPE(state, grid) {
    state.grid = grid
  },
  SET_VEHICLES(state, vehicles) {
    state.vehicles = vehicles
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_VEHICLE_PAGE(state, page) {
    state.page = page
  },
  SET_PAGE(state, page) {
    state.page = page
  },
  SET_LAST_PAGE(state, lastPage) {
    state.lastPage = lastPage
  },
  DELETE_VEHICLE(state, vehicle) {
    const index = state.vehicles.map(vehicle => vehicle.id).indexOf(vehicle.id)
    state.vehicles.splice(index, 1)
  },
  OPEN_EXCEL_MODAL(state, payload) {
    state.excelModal = payload
  },
  SET_DEFAULT_MARKET_VALUE_DIALOG(state, setDefaultMarketValueDialog) {
    state.setDefaultMarketValueDialog = setDefaultMarketValueDialog;
  },
  SET_MARKET_VALUE_HISTORY_DIALOG(state, setMarketValueHistoryDialog) {
    state.setMarketValueHistoryDialog = setMarketValueHistoryDialog;
  },
  SET_SELL_DIALOG(state, setSellDialog) {
    state.setSellDialog = setSellDialog;
  },
  SET_SELL_HISTORY_DIALOG(state, setSellHistoryDialog) {
    state.setSellHistoryDialog = setSellHistoryDialog;
  },
}
const getters = {
  getSelectedVehicle: state => state.selectedVehicle
}

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
